import { getDefaultHeaders } from '../defaultHeaders'
import tools from '../../constants/tools';
import axios from 'axios';
import sitemap from '../../common/sitemap'
import { GetUrl } from './utilities';

class _ToolService {
    constructor() {
        this.cancelTokenSource = axios.CancelToken.source();
        axios.defaults.timeout = 600000;
    }

    cancelRequest = () => {
        this.cancelTokenSource.cancel("");
        this.cancelTokenSource = null;
        this.cancelTokenSource = axios.CancelToken.source();
    }
    _action = (url, data) => {
        var _this = this;
        return axios.post(
            url,
            data,
            {
                headers: getDefaultHeaders(),
                cancelToken: _this.cancelTokenSource.token,
                timeout: 600000 // 10 min
            });
    }

    combinePdf = (data) => {
        return this._action(GetUrl(tools.combine.action), data);
    }

    compressPdf = (data) => {
        return this._action(GetUrl(tools.compress.actionUrl), data);
    }

    convertToPdf = (data) => {
        return this._action(GetUrl(tools.convert.actionUrl), data);
    }

    eSignPdf = (data) => {
        return this._action(GetUrl(tools.esign.actionUrl), data);
    }

    cropPdf = (data) => {
        return this._action(GetUrl(tools.cropPdf.actionUrl), data);
    }

    hyperCompressPdf = (data) => {
        return this._action(GetUrl(tools.hyperCompress.actionUrl), data);
    }

    mergePdf = (data) => {
        return this._action(GetUrl(tools.merge.actionUrl), data);
    }

    combinePdf = (data) => {
        return this._action(GetUrl(tools.combine.actionUrl), data);
    }

    organizePdf = (data) => {
        return this._action(GetUrl(tools.organize.actionUrl), data);
    }

    protectPdf = (data) => {
        return this._action(GetUrl(tools.protect.actionUrl), data);
    }

    rotatePdf = (data) => {
        return this._action(GetUrl(tools.rotate.actionUrl), data);
    }

    splitPdf = (data) => {
        return this._action(GetUrl(tools.split.actionUrl), data);
    }

    unlockPdf = (data) => {
        return this._action(GetUrl(tools.unlock.actionUrl), data);
    }

    wordToPdf = (data) => {
        return this._action(GetUrl(tools.convert.actionUrl), data);
    }

    excelToPdf = (data) => {
        return this._action(GetUrl(tools.convert.actionUrl), data);
    }

    tiffToPdf = (data) => {
        return this._action(GetUrl(tools.convert.actionUrl), data);
    }

    jpgToPdf = (data) => {
        return this._action(GetUrl(tools.convert.actionUrl), data);
    }

    pngToPdf = (data) => {
        return this._action(GetUrl(tools.convert.actionUrl), data);
    }

    dxfToPdf = (data) => {
        return this._action(GetUrl(tools.convert.actionUrl), data);
    }

    svgToPdf = (data) => {
        return this._action(GetUrl(tools.svgToPdf.actionUrl), data);
    }

    convertToPdfA = (data) => {
        return this._action(GetUrl(tools.convertA.actionUrl), data);
    }

    pdfOCR = (data) => {
        return this._action(GetUrl(tools.ocr.actionUrl), data);
    }

    removePdfPages = (data) => {
        return this._action(GetUrl(tools.removePages.actionUrl), data);
    }

    convertPdfToTiff = (data) => {
        return this._action(GetUrl(tools.pdfToTiff.actionUrl), data);
    }

    convertPdfToJpeg = (data) => {
        return this._action(GetUrl(tools.pdfToJpg.actionUrl), data);
    }

    flattenPdf = (data) => {
        return this._action(GetUrl(tools.flattenPdf.actionUrl), data);
    }

    resizePdf = (data) => {
        return this._action(GetUrl(tools.resizePdf.actionUrl), data);
    }

    removeDocumentContent = (data) => {
        return this._action(GetUrl(tools.removeDocumentContent.actionUrl), data);
    }

    removeInteractiveContent = (data) => {
        return this._action(GetUrl(tools.removeInteractiveContent.actionUrl), data);
    }

    scanTopdf = (data) => {
        return this._action(GetUrl(tools.scanningToPdf.actionUrl), data);
    }

    fillOutPdfForm = (data) => {
        return this._action(GetUrl(tools.formFieldsFilling.actionUrl), data);
    }

    pdfToText = (data) => {
        return this._action(GetUrl(tools.pdfToText.actionUrl), data);
    }

    textToPdf = (data) => {
        return this._action(GetUrl(tools.textToPdf.actionUrl), data);
    }

    markupPdf = (data) => {
        return this._action(GetUrl(tools.markupPdf.actionUrl), data);
    }

    redactPdf = (data) => {
        return this._action(GetUrl(tools.redactPdf.actionUrl), data);
    }

    dicomToPdf = (data) => {
        return this._action(GetUrl(tools.dicomToPdf.actionUrl), data);
    }

    extractPdfPages = (data) => {
        return this._action(GetUrl(tools.extractPdfPages.actionUrl), data);
    }

    pdfRepair = (data) => {
        return this._action(GetUrl(tools.pdfRepair.actionUrl), data);
    }

    convertToOnePagePdf
        = (data) => {
            return this._action(GetUrl(tools.convertToOnePagePdf.actionUrl), data);
        }

    //toolHelpers part
    getImageCropped = (data) => {
        return this._action(GetUrl(["tools", sitemap.GET_IMAGE_CROPPED]), data);
    }
    //

    getEmbedCodeSnippet = (data) => {
        return this._action(GetUrl(["tools", sitemap.GET_EMBED_CODE_SNIPPET]), data);
    }

    editPdf = (data) => {
        return this._action(GetUrl(tools.edit.actionUrl), data);
    }

    cleanPdf = (data) => {
        return this._action(GetUrl(tools.clean.actionUrl), data);
    }


    pptxToPdf = (data) => {
        return this._action(GetUrl(tools.pptxToPdf.actionUrl), data);
    }

    insertPage = (data) => {
        return this._action(GetUrl(tools.insertPage.actionUrl), data);
    }

    removeText = (data) => {
        return this._action(GetUrl(tools.removeText.actionUrl), data);
    }

    optimizeForWeb = (data) => {
        return this._action(GetUrl(tools.optimizeForWeb.actionUrl), data);
    }

    reversePdf = (data) => {
        return this._action(GetUrl(tools.reversePdf.actionUrl), data);
    }

    // nupPdf = (data) => {
        //return this._action(GetUrl(tools.compress.actionUrl), data);
    // }

    pdfToPng = (data) => {
        return this._action(GetUrl(tools.pdfToPng.actionUrl), data);
    }

    pagingPdf = (data) => {
        return this._action(GetUrl(tools.numbers.actionUrl), data);
    }

    barcodeReco = (data) => {
        return this._action(GetUrl(tools.barcodeReco.actionUrl), data);
    }

    pdfaValidation = (data) => {
        return this._action(GetUrl(tools.validationA.actionUrl), data);
    }

    convertToGrayscale = (data) => {
        return this._action(GetUrl(tools.convertToGrayscale.actionUrl), data);
    }

    docuviewareSave = (data) => {
        return this._action(GetUrl(["tools", sitemap.DOCUVIEWARE_SAVE_ACTION_ROUTE]), data);
    }

    editPdfMeta = (data) => {
        return this._action(GetUrl(tools.editPdfMeta.actionUrl), data);
    }

    getPdfInfo = (data) => {
        return this._action(GetUrl(["tools", sitemap.GET_PDF_INFO_ROUTE]), data);
    }
    watermark = (data) => {
        return this._action(GetUrl(["tools", sitemap.WATERMARK_PDF_ACTION_ROUTE]), data);
    }
    imageToExcel = (data) => {
        return this._action(GetUrl(["tools", sitemap.IMAGE_TO_EXCEL_ACTION_ROUTE]), data);
    }
    PdfToWord = (data) => {
        return this._action(GetUrl(["tools", sitemap.PDF_TO_WORD_ACTION_ROUTE]), data);
    }
    PdfToExcel = (data) => {
        return this._action(GetUrl(["tools", sitemap.PDF_TO_EXCEL_ACTION_ROUTE]), data);
    }
    PdfToPowerPoint = (data) => {
        return this._action(GetUrl(["tools", sitemap.PDF_TO_POWERPOINT_ACTION_ROUTE]), data);
    }
};

const ToolService = new _ToolService();
export default ToolService;